export const isSameFile = async (a: File, b: File): Promise<boolean> => {
  if (a.size !== b.size) return false;
  // Empty placeholder files (e.g. from API attachments) carry no bytes to compare
  if (a.size === 0) return a.name === b.name;

  // arrayBuffer() over the newer bytes(), which older Safari/Firefox lack
  const [bufferA, bufferB] = await Promise.all([a.arrayBuffer(), b.arrayBuffer()]);
  const bytesB = new Uint8Array(bufferB);
  return new Uint8Array(bufferA).every((byte, i) => byte === bytesB[i]);
};
